import {store} from '../../store/global-store';
import {AdvertActionsCommands} from '../../store/advert-actions';

function initCascadeModalMediator(app) {

    app.component('cascade-modal-mediator', {
        methods: {
            _setCurrentModal(actionName) {
                this.currentModal = this.currentCascade.modals.find(item => item.openModalEventName === actionName);
            }
        },
        data() {
            return {
                currentCascade: {},
                currentModal: {},
            };
        },
        props: {
            modalsArray: Array,
        },
        mounted() {
            store.subscribe((mutation) => {
                if (mutation.type === AdvertActionsCommands.OpenCascadeModal) {
                    const cascadeModal = this.modalsArray.find(item => item.cascadeName === mutation.payload.type);

                    this.currentCascade = cascadeModal;
                    this._setCurrentModal(cascadeModal.initialModalName);

                    store.commit(cascadeModal.initialModalName, mutation.payload.model);
                }
            });

            store.subscribe((mutation) => {
                if (mutation.type === AdvertActionsCommands.NavigateCascadeModal) {
                    const nextModal = this.currentModal[mutation.payload.actionName];
                    this._setCurrentModal(nextModal);
                    store.commit(nextModal, mutation.payload.model);
                }
            });
        },
        render() {
            return null;
        },
    });
}

export {initCascadeModalMediator};
